import SFullPage from './style.module.scss';
import FadeIn from '../../commonComponents/fadeIn';
import { src } from '../../../utils/common';
import { useRef, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { useUserAgentInfo } from '../../../context/user-agent';
import { WebPNextImage as Image, WebPNativeImage } from '../../WebPImage';
import Link from 'next/link';

// 移动端 文字对齐方式
declare type MobilePosition = 'left' | 'center';

const PageSection = ({
  data,
  mobilePosition = 'center',
  scale = 1.2,
  width,
  height,
  mobileWidth,
  mobileHeight,
  linkUrl = '',
  backgroundColor = 'FFF',
  distance = 201,
}: {
  data: any;
  mobilePosition?: MobilePosition;
  scale?: number;
  width?: number;
  height?: number;
  mobileWidth?: number;
  mobileHeight?: number;
  buttonConfig?: { buttonText: string; linkText: string };
  linkUrl?: string;
  backgroundColor?: string;
  distance?: number;
}) => {
  const ref = useRef(null);
  const { isMobile } = useUserAgentInfo();
  useEffect(() => {
    const dom = ref.current;
    const viewHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const onScroll = () => {
      const upper = dom.getBoundingClientRect().top;
      if (upper < viewHeight && upper > -viewHeight) {
        if (upper < viewHeight - 200 && upper > 0) {
          dom.style.transform = `scale(${
            1 + ((scale - 1) * (viewHeight - upper - 200)) / (viewHeight - 200)
          })`;
        }
      }
    };
    window.addEventListener('scroll', throttle(onScroll, 50));
  }, []);

  const DescContent = () => {
    return (
      <FadeIn>
        <div
          className={SFullPage['content']}
          style={{
            textAlign: 'left',
            marginRight: !isMobile ? `${distance}px` : '0px',
          }}
        >
          <div className={SFullPage['title']}>{data.title}</div>
          {/* FadeIn 会覆盖子元素的opacity属性 */}
          <div style={{ opacity: '0.6' }}>
            <FadeIn delay={500}>
              <div className={SFullPage['desc']}>{data.desc}</div>
            </FadeIn>
          </div>
          <div className={SFullPage['link']}>
            <Link href={linkUrl} passHref>
              <span className={SFullPage['link-text']}>了解更多 {'>'}</span>
            </Link>
          </div>
        </div>
      </FadeIn>
    );
  };

  const MediaContent = () => {
    return (
      <div className={SFullPage['media']}>
        <div ref={ref} className={SFullPage['media-image']}>
          {!isMobile ? (
            <Image
              src={data.picUrl}
              width={width}
              height={height}
              alt="sound matrix示例图片"
            />
          ) : (
            <Image
              src={data.picUrlMobile}
              width={mobileWidth}
              height={mobileHeight}
              alt="sound matrix示例图片"
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={`${SFullPage['section']} ${
          SFullPage[isMobile ? mobilePosition : 'left']
        }`}
        style={{
          background: backgroundColor,
        }}
      >
        <DescContent />
        <MediaContent />
      </div>
    </>
  );
};

export default PageSection;
